import React from "react";
import { ContentState, EditorState } from "draft-js";
import Editor, { composeDecorators } from "@draft-js-plugins/editor";
import createImagePlugin from "@draft-js-plugins/image";
import createFocusPlugin from "@draft-js-plugins/focus";
import createResizeablePlugin from "@draft-js-plugins/resizeable";
import createBlockDndPlugin from "@draft-js-plugins/drag-n-drop";
import htmlToDraft from "html-to-draftjs";

const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
const blockDndPlugin = createBlockDndPlugin();

const decorator = composeDecorators(
	resizeablePlugin.decorator,
	focusPlugin.decorator,
	blockDndPlugin.decorator
);

const imagePlugin = createImagePlugin({ decorator });

const plugins = [blockDndPlugin, focusPlugin, resizeablePlugin, imagePlugin];

export const styleMap = {
	CODE: {
		backgroundColor: "rgba(0, 0, 0, 0.05)",
		fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
		fontSize: 16,
		padding: 2,
	},
};

export function getBlockStyle(block) {
	switch (block.getType()) {
		case "blockquote":
			return "RichEditor-blockquote";
		default:
			return null;
	}
}

const getData = (data) => {
	const contentBlock = htmlToDraft(data);
	if (contentBlock) {
		const contentState = ContentState.createFromBlockArray(
			contentBlock.contentBlocks
		);
		const editorState = EditorState.createWithContent(contentState);
		return editorState;
	} else {
		return EditorState.createEmpty();
	}
};

const RichViewer = ({ data }) => {
	const html = data ? getData(data) : EditorState.createEmpty();
	return (
		<div className="RichEditor-root">
			<div className="RichEditor-editor">
				<Editor
					blockStyleFn={getBlockStyle}
					customStyleMap={styleMap}
					editorState={html}
					plugins={plugins}
					readOnly={true}
				/>
			</div>
		</div>
	);
};

export default RichViewer;
